import styled from 'styled-components';

import { BLACK, BG_GRAY } from '@/styles/variables.style';
import media from '@/styles/media.style';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;

  ${media.tabletL`
    padding: 60px 40px;
  `};
`;

export const Container = styled.div`
  width: 100%;
  background: ${BG_GRAY.COMMON_1};
  padding: 30px;

  ${media.tabletL`
    max-width: 1060px;
    margin: auto;
    padding: 40px;
  `};
`;

export const Title = styled.h4`
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 30px;

  ${media.tabletL`
    margin-bottom: 40px;
  `};
`;

export const ItemsWrapper = styled.div`
  margin: 0;
`;

export const Items = styled.ul`
  margin: 0;
  list-style: none;
`;

export const Item = styled.li`
  margin-bottom: ${({ isLast }) => (!isLast ? '20px' : '0')};
  cursor: pointer;
  color: ${BLACK};
  text-decoration: underline;

  ${media.tabletL`
    margin-bottom: ${({ isLast }) => (!isLast ? '30px' : '0')};
    font-size: 13px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Article/TableOfContentsSection.style.js